import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: theme.spacing(13),
    height: theme.spacing(13),
    objectFit: "cover",
    borderRadius: 4,
  },
  card: {
    // width: "100%",
    padding: theme.spacing(2),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: LIGHT_GREY,
    },
  },
  iconTypeCampaign: {
    height: "18px",
    width: "18px",
    marginRight: "8px",
  },
}));
